import { createFileRoute } from '@tanstack/react-router'

import { GenericProblemMessage } from '../../../../components/organisms/generic-problem-message.tsx'
import { PlatformOrganizationMembersPage } from '../../../../components/pages/backoffice/platform/platform-organization-page/platform-organization-members-page.tsx'
import { InviteToLoginPage } from '../../../../components/templates/invite-to-login/invite-to-login-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'
import { useBackofficeUser } from '../../../../lib/use-permissions.ts'

export const Route = createFileRoute('/bo/organizations/$organizationTechnicalName/members')({
  component: function Component() {
    const { organizationTechnicalName } = Route.useParams()
    const backofficeUser = useBackofficeUser()

    if (!backofficeUser) {
      return <InviteToLoginPage />
    }

    if (backofficeUser.type !== 'platform') {
      return (
        <GenericProblemMessage
          title="Accès refusé"
          principalMessage="Cette page est réservée aux utilisateurs plateforme."
          firstSubText="Vous n'avez pas les droits nécessaires pour accéder à cette page."
          onButtonClick={() => window.history.back()}
          buttonText="Revenir à la page précédente"
        />
      )
    }

    return (
      <PermissionChecker requiredPermissions={['organization.view', 'membership.read']}>
        <PlatformOrganizationMembersPage organizationTechnicalName={organizationTechnicalName} />
      </PermissionChecker>
    )
  },
})
